module.exports = __webpack_public_path__ + "img/default-bg-image.acdecb66.png";